import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
import reportWebVitals from './reportWebVitals';

// Enable React Router v7 compatibility flags
if (process.env.NODE_ENV === 'development') {
  // Enable future-facing features for React Router v7
  window.__ROUTER_BASENAME__ = '/';
  window.__ROUTER_FUTURE__ = {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
